export const MediaTreeNodeType = {
  AGGLOMERATION: 'Media::Agglomeration',
  CITY: 'Media::City',
  BUILDING: 'Media::Building',
  MEDIUM: 'Medium',
}

export interface BroadSignCreationMediumUsage {
  id: string
  used: boolean
}

export interface BroadSignMediaTreeMedium {
  id: string
  type: string
  used: boolean | null
}

export interface BroadSignMediaTreeBuilding {
  id: string
  name: string
  type: string
  // null until the gallery gets a record of its own, the tree builder fills it from that record
  acceptanceStatus: string | null
  children: BroadSignMediaTreeMedium[]
}

export interface BroadSignMediaTreeCity {
  id: string
  name: string
  type: string
  children: BroadSignMediaTreeBuilding[]
}

export interface BroadSignMediaTreeAgglomeration {
  id: string
  name: string
  type: string
  children: BroadSignMediaTreeCity[]
}
